import { configuratorBuilder } from 'sunlife-domain'

import { createAdminInterface } from '@salsita-ai/platform-project-sdk/admin'

export const adminInterface = createAdminInterface(configuratorBuilder)
